export default __webpack_public_path__ + "static/media/weezpay-no-icon.86418897.png";